(function () {
  'use strict';
  var T = window.theme || { routes: {}, moneyFormat: '${{amount}}', cartType: 'drawer' };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = T.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Drawers */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = $('button, a', $('.drawer__panel', d)); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    var cartLink = t.closest('[data-cart-open]');
    if (cartLink && T.cartType !== 'page' && $('#CartDrawer')) { e.preventDefault(); refreshCart().then(function () { openDrawer('cart'); }); return; }
    var search = t.closest('[data-search-toggle]');
    if (search) {
      var bar = $('[data-search-bar]');
      if (bar) { bar.hidden = !bar.hidden; if (!bar.hidden) { var i = $('input[type="search"]', bar); if (i) i.focus(); } }
      return;
    }
    var line = t.closest('[data-line-change]');
    if (line) { e.preventDefault(); changeLine(line.getAttribute('data-line-change'), parseInt(line.getAttribute('data-qty'), 10)); return; }
    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input[name="quantity"]', step.closest('.qty, .pp__qty'));
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* Cart drawer (rendered by the 'cart-drawer' section via the Section Rendering API) */
  var CART_SECTION = 'cart-drawer';
  var TIMER_KEY = 'lmd_cart_timer_end';

  function applyCartSection(html) {
    if (!html) return;
    var panel = $('[data-cart-panel]');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-content]');
    var current = panel && $('[data-cart-drawer-content]', panel);
    if (fresh && current) current.replaceWith(fresh);
    afterCartRender();
  }
  function afterCartRender() {
    var cd = $('[data-cart-drawer-content]');
    if (!cd) return;
    var count = parseInt(cd.getAttribute('data-item-count'), 10) || 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
    // reservation timer: starts with the first item, keeps running across pages, clears when cart is emptied
    try {
      if (count === 0) localStorage.removeItem(TIMER_KEY);
      else if (!localStorage.getItem(TIMER_KEY)) {
        var mins = parseInt(cd.getAttribute('data-timer-minutes'), 10) || 15;
        localStorage.setItem(TIMER_KEY, String(Date.now() + mins * 60000));
      }
    } catch (e) {}
    updateProgress(cd);
    try {
      var saved = sessionStorage.getItem('lmd_copied_code');
      var inp = $('#CartDiscount', cd);
      if (saved && inp && !inp.value && currentCodes().map(function (c) { return c.toLowerCase(); }).indexOf(saved.toLowerCase()) === -1) inp.value = saved;
    } catch (err) {}
    tickCart();
  }
  function sectionsUrl() { return root + '?sections=' + CART_SECTION; }
  function refreshCart() {
    return fetch(sectionsUrl(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { applyCartSection(j[CART_SECTION]); })
      .catch(function () {});
  }
  function setLoading(on) { var cd = $('[data-cart-drawer-content]'); if (cd) cd.classList.toggle('is-loading', on); }
  function postCart(endpoint, payload) {
    payload.sections = CART_SECTION;
    payload.sections_url = window.location.pathname;
    setLoading(true);
    return fetch(root + endpoint, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j.sections) applyCartSection(res.j.sections[CART_SECTION]);
        else if (res.ok) return refreshCart().then(function () { return res; });
        else setLoading(false);
        return res;
      })
      .catch(function () { setLoading(false); return { ok: false, j: {} }; });
  }
  function changeLine(key, qty) {
    return postCart('cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(function (res) {
      if (!res.ok && res.j && res.j.description) showDiscountMsg(res.j.description);
    });
  }

  /* Free shipping bar (handles multi-currency via Shopify.currency.rate) */
  function updateProgress(cd) {
    var box = $('[data-progress]', cd); if (!box) return;
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var threshold = Math.round((parseInt(cd.getAttribute('data-threshold'), 10) || 0) * rate);
    var total = parseInt(cd.getAttribute('data-total'), 10) || 0;
    var left = threshold - total;
    var pct = threshold > 0 ? Math.min(100, Math.round(total / threshold * 100)) : 100;
    var fill = $('[data-progress-fill]', box); if (fill) fill.style.width = pct + '%';
    var text = $('[data-progress-text]', box);
    box.classList.toggle('is-done', left <= 0);
    if (text) {
      text.innerHTML = left > 0
        ? '<span aria-hidden="true">&#9203;</span> ' + esc(box.getAttribute('data-text-away')).replace('[amount]', '<strong>' + esc(formatMoney(left)) + '</strong>')
        : '<span aria-hidden="true">&#127881;</span> ' + esc(box.getAttribute('data-text-done'));
    }
  }

  /* Delivery estimate */
  function zonedNow(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, min: +o.minute, s: +o.second };
    } catch (e) {
      var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours(), min: n.getMinutes(), s: n.getSeconds() };
    }
  }
  function addDays(date, days, businessOnly) {
    var d = new Date(date.getTime());
    if (!businessOnly) { d.setUTCDate(d.getUTCDate() + days); return d; }
    var added = 0;
    while (added < days) { d.setUTCDate(d.getUTCDate() + 1); var wd = d.getUTCDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function fmtDay(d) {
    return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  }
  function updateDelivery() {
    var box = $('[data-delivery]'); if (!box) return;
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10); if (isNaN(cutoff)) cutoff = 14;
    var minD = parseInt(box.getAttribute('data-min'), 10) || 0;
    var maxD = parseInt(box.getAttribute('data-max'), 10) || minD;
    var business = box.getAttribute('data-business') === 'true';
    var now = zonedNow(box.getAttribute('data-tz') || 'America/Chicago');
    var orderDay = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var secsNow = now.h * 3600 + now.min * 60 + now.s;
    var secsLeft = cutoff * 3600 - secsNow;
    if (secsLeft <= 0) { orderDay.setUTCDate(orderDay.getUTCDate() + 1); secsLeft += 86400; }
    var start = addDays(orderDay, minD, business);
    var end = addDays(orderDay, Math.max(minD, maxD), business);
    var h = Math.floor(secsLeft / 3600), m = Math.floor((secsLeft % 3600) / 60);
    var countdown = (h > 0 ? h + ' h ' : '') + m + ' min';
    var tpl = esc(box.getAttribute('data-template') || '');
    var html = tpl.replace('[start]', '<strong>' + esc(fmtDay(start)) + '</strong>')
                  .replace('[end]', '<strong>' + esc(fmtDay(end)) + '</strong>')
                  .replace('[countdown]', '<strong>' + esc(countdown) + '</strong>');
    var p = $('[data-delivery-text]', box);
    if (p && p.innerHTML !== html) p.innerHTML = html;
    box.hidden = false;
  }

  /* Reservation timer */
  function tickCart() {
    var timer = $('[data-cart-timer]');
    if (timer) {
      var end = 0;
      try { end = parseInt(localStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) {}
      var left = Math.floor((end - Date.now()) / 1000);
      if (end && left > 0) {
        var mm = Math.floor(left / 60), ss = left % 60;
        var clock = $('[data-cart-timer-clock]', timer);
        if (clock) clock.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
        timer.hidden = false;
      } else {
        timer.hidden = true;
      }
    }
    updateDelivery();
  }
  setInterval(tickCart, 1000);
  afterCartRender();

  /* Discount codes (Cart AJAX API: /cart/update.js { discount: "CODE1,CODE2" }) */
  function currentCodes() {
    var list = $('[data-codes]');
    return list ? list.getAttribute('data-codes').split(',').filter(Boolean) : [];
  }
  function showDiscountMsg(msg, ok) {
    var el = $('[data-discount-msg]'); if (!el) return;
    el.textContent = msg; el.hidden = !msg; el.classList.toggle('is-ok', !!ok);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = $('input[name="discount"]', form);
    var code = (input.value || '').trim();
    if (!code) { showDiscountMsg('Please enter a discount code.'); return; }
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    postCart('cart/update.js', { discount: codes.join(',') }).then(function (res) {
      if (!res.ok) { showDiscountMsg((res.j && res.j.description) || 'Could not apply that code.'); return; }
      var dc = res.j.discount_codes;
      var hit = dc && dc.filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (dc && (!hit || !hit.applicable)) showDiscountMsg('"' + code + '" isn’t valid for the items in your cart.');
      else if (!dc) showDiscountMsg('Code saved — it will be applied at checkout.', true);
      else showDiscountMsg('Discount applied!', true);
    });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-remove-code]');
    if (!rm) return;
    e.preventDefault();
    var code = rm.getAttribute('data-remove-code');
    var codes = currentCodes().filter(function (c) { return c !== code; });
    postCart('cart/update.js', { discount: codes.join(',') });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* Product form */
  $$('[data-product-form]').forEach(function (form) {
    var section = form.closest('[data-product-section]') || document;
    var jsonEl = $('[data-product-json]', section);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var invEl = $('[data-inventory-json]', section);
    var inventory = {};
    try { inventory = invEl ? JSON.parse(invEl.textContent) : {}; } catch (e) { inventory = {}; }
    var idSelect = $('[data-variant-select]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form) || addBtn;
    var errorEl = $('[data-form-error]', form);
    var optionSelects = $$('[data-option-index]', form);
    var addText = addBtn.getAttribute('data-label') || 'Add to cart';
    var soldText = addBtn.getAttribute('data-soldout') || 'Sold out';

    function currentVariant() {
      if (!product) return null;
      var values = optionSelects.map(function (s) { return s.value; });
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v.options.every(function (o, k) { return values[k] === undefined || o === values[k]; })) return v;
      }
      return null;
    }
    function updateStock(v) {
      var el = $('[data-stock]', section); if (!el) return;
      var qty = v ? inventory[String(v.id)] : null;
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
      el.classList.remove('is-low');
      if (!v || !v.available) { el.textContent = el.getAttribute('data-out'); }
      else if (qty !== null && qty !== undefined && qty > 0 && qty <= threshold) {
        el.textContent = (el.getAttribute('data-low') || '').replace('[count]', qty); el.classList.add('is-low');
      } else { el.textContent = el.getAttribute('data-in'); }
    }
    function update() {
      var v = currentVariant();
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; updateStock(null); return; }
      idSelect.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addText : soldText;
      var priceEl = $('[data-price]', section);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var cmp = $('[data-compare]', section);
      if (cmp) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        cmp.hidden = !sale; if (sale) cmp.textContent = formatMoney(v.compare_at_price);
      }
      updateStock(v);
      if (v.featured_image && v.featured_image.id) showImage(section, v.featured_image.id);
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', update); });

    form.addEventListener('submit', function (e) {
      if (T.cartType === 'page') return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      addBtn.disabled = true;
      var label = addLabel.textContent; addLabel.textContent = 'Adding…';
      var fd = new FormData(form);
      fd.append('sections', CART_SECTION);
      fd.append('sections_url', window.location.pathname);
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          // a new item restarts the reservation timer
          try { localStorage.removeItem(TIMER_KEY); } catch (e) {}
          if (res.j.sections && res.j.sections[CART_SECTION]) { applyCartSection(res.j.sections[CART_SECTION]); openDrawer('cart'); return; }
          return refreshCart().then(function () { openDrawer('cart'); });
        })
        .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
        .then(function () { addBtn.disabled = false; addLabel.textContent = label; });
    });
  });

  /* Product gallery: mobile slider dots + variant image */
  var mqMobile = window.matchMedia('(max-width: 749px)');
  function showImage(section, imageId) {
    var slider = $('[data-slider]', section); if (!slider) return;
    var slide = $('[data-image-id="' + imageId + '"]', slider); if (!slide) return;
    if (mqMobile.matches) {
      slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      if (window.lmdFitSlider) window.lmdFitSlider(slider, Array.prototype.indexOf.call(slider.children, slide));
    } else if (slider.firstElementChild !== slide) {
      slider.insertBefore(slide, slider.firstElementChild);
      var top = slider.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
  $$('[data-slider]').forEach(function (slider) {
    var section = slider.closest('[data-product-section]');
    var dots = section ? $$('[data-dot]', section) : [];
    var fit = function (i) { if (window.lmdFitSlider) window.lmdFitSlider(slider, i); };
    var current = 0;
    // keep the slider exactly as tall as the photo being shown (no white bands)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { fit(current); }, 100);
    });
    $$('img', slider).forEach(function (img, i) {
      if (!img.complete) img.addEventListener('load', function () { if (i === current) fit(current); });
    });
    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
        if (idx !== current) { current = idx; fit(idx); }
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });
    fit(current);
    if (!dots.length) return;
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-dot'), 10);
        var slide = slider.children[i];
        if (slide) slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      });
    });
  });

  /* Recently viewed */
  (function () {
    var KEY = 'lmd_recently_viewed';
    var section = $('[data-product-section][data-product-handle]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); if (!Array.isArray(list)) list = []; } catch (e) { list = []; }
    var current = section ? section.getAttribute('data-product-handle') : null;
    var wrap = $('[data-recently-viewed]');
    if (wrap) {
      var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 8;
      var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
      if (handles.length) {
        Promise.all(handles.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (items) {
          items = items.filter(Boolean);
          if (!items.length) return;
          var grid = $('[data-recent-grid]', wrap);
          grid.innerHTML = items.map(function (p) {
            var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
            var ratio = (p.media && p.media[0] && p.media[0].aspect_ratio) || 1;
            var cmp = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + formatMoney(p.compare_at_price) + '</s>' : '';
            return '<div class="rcard"><a href="' + esc(p.url) + '" class="rcard__link"><div class="rcard__media">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" class="rcard__img" style="aspect-ratio:' + ratio + '">' : '<span class="rcard__img rcard__img--empty"></span>') +
              '</div><span class="rcard__title">' + esc(p.title) + '</span><span class="rcard__price">' + cmp + '<span>' + formatMoney(p.price) + '</span></span></a></div>';
          }).join('');
          wrap.hidden = false;
        });
      }
    }
    if (current) {
      list = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 20);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
  })();

  /* Masonry (collection pages): initial layout runs inline in the section (before first paint); re-run on resize */
  var masonryGrids = $$('[data-masonry]');
  if (masonryGrids.length && window.lmdMasonry) {
    var mTimer, lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(mTimer);
      mTimer = setTimeout(function () { masonryGrids.forEach(window.lmdMasonry); }, 150);
    });
  }

  /* Infinite scroll (collection pages): loads the next page when the shopper nears the end */
  (function () {
    var box = $('[data-infinite]');
    var grid = $('[data-masonry]');
    if (!box || !grid) return;
    var loader = $('[data-infinite-loader]', box);
    var moreBtn = $('[data-infinite-more]', box);
    var sectionId = box.getAttribute('data-section-id');
    var nextUrl = box.getAttribute('data-next-url');
    var loading = false;

    function placeItem(item) {
      item.classList.add('is-new');
      var cols = grid.classList.contains('is-laid') ? $$('.masonry__col', grid) : [];
      if (!cols.length) { grid.appendChild(item); }
      else {
        var target = cols[0], min = Infinity;
        cols.forEach(function (c) { var h = c.getBoundingClientRect().height; if (h < min - 1) { min = h; target = c; } });
        target.appendChild(item);
      }
      if (grid._items) grid._items.push(item);
    }
    function finish() {
      if (observer) observer.disconnect();
      box.remove();
    }
    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      loader.hidden = false; moreBtn.hidden = true;
      var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = $$('[data-masonry-item]', doc);
          items.forEach(function (it) { placeItem(document.importNode(it, true)); });
          var nextBox = $('[data-infinite]', doc);
          nextUrl = nextBox ? nextBox.getAttribute('data-next-url') : null;
          loading = false;
          loader.hidden = true;
          if (!nextUrl || !items.length) { finish(); return; }
          // keep going if the sentinel is still on screen (e.g. tall screens)
          var r = box.getBoundingClientRect();
          if (r.top < window.innerHeight + 800) loadNext();
        })
        .catch(function () {
          loading = false;
          loader.hidden = true;
          moreBtn.hidden = false;   // let the shopper retry manually
        });
    }
    moreBtn.addEventListener('click', loadNext);
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
      }, { rootMargin: '0px 0px 1200px 0px' });
      observer.observe(box);
    } else {
      moreBtn.hidden = false;
    }
  })();

  /* Copy discount code button */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-copy-code]');
    if (!btn) return;
    var code = btn.getAttribute('data-copy-code');
    var done = function () {
      var tip = $('[data-copied]', btn);
      if (tip) { tip.hidden = false; clearTimeout(btn._t); btn._t = setTimeout(function () { tip.hidden = true; }, 1600); }
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      ta.remove(); done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
    // remember it so the cart drawer's discount box is pre-filled
    try { sessionStorage.setItem('lmd_copied_code', code); } catch (err) {}
    var input = $('#CartDiscount'); if (input && !input.value) input.value = code;
  });

  /* Product card hover image: fetched only on first hover (saves an image per card) */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.card');
      if (!card || card._hoverLoaded) return;
      card._hoverLoaded = true;
      var img = $('img[data-hover-src]', card);
      if (!img) return;
      img.onload = function () { img.hidden = false; };
      img.src = img.getAttribute('data-hover-src');
    }, { passive: true });
  }

  /* Collection sort */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Address country defaults */
  $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });

  /* Recover password toggle */
  $$('[data-recover-toggle]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); var r = $('#RecoverEmail'); if (r) r.focus(); }); });
})();
